import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { SnackBarService } from "#core/services";
import { AssetsService } from "@carnegie-learning/data-access-angular-cure";
import * as assetsActions from "../actions/student-assets.action";

@Injectable()
export class StudentAssetsEffects {
    constructor(
        private actions$: Actions,
        private assetsService: AssetsService,
        private snackBarService: SnackBarService
    ) {}

    loadAssets$ = createEffect(() =>
        this.actions$.pipe(ofType(assetsActions.LoadAssets)).pipe(
            switchMap((action) => {
                return this.assetsService
                    .getAssets(action.paginationParams)
                    .pipe(
                        map((assets) => assets),
                        map((assets) =>
                            assetsActions.LoadAssetsSuccess({ payload: assets })
                        ),
                        catchError((error) =>
                            of(assetsActions.LoadAssetsFail({ payload: error }))
                        )
                    );
            })
        )
    );

    loadSelectedAsset$ = createEffect(() =>
        this.actions$.pipe(ofType(assetsActions.LoadAsset)).pipe(
            switchMap((payload) => {
                return this.assetsService
                    .getSelectedAsset(payload.assetId)
                    .pipe(
                        map((response) =>
                            assetsActions.LoadAssetSuccess({
                                payload: response,
                            })
                        ),
                        catchError((error) =>
                            of(assetsActions.LoadAssetFail({ payload: error }))
                        )
                    );
            })
        )
    );
}
